import {createContext} from 'react'

export const ReceiptContext = createContext({})